import CollectionBundle from './Types/CollectionBundle';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import ReportFieldDefinition from '../../../types/report/ReportFieldDefinition';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import IngestionMode from '../../../types/ingestion/IngestionMode';
import { AxiosResponse } from 'axios';
import ImportReportConfig from '../../../types/report/ImportReportConfig';

const getConfigDataSources = (clientDataSourceIds: number[], globalRefDataSourceIds: number[]): Promise<IngestionConfig[]> => {

    let client = clientDataSourceIds.map(id => urlHelper.buildRoute(['ingestion', id]));
    let globalRef = globalRefDataSourceIds.map(id => urlHelper.buildRoute(['global-ref-data-source', id]));

    let calls = client.concat(globalRef).map(route => httpClient.get<IngestionConfig>(route));

    return new Promise<IngestionConfig[]>(resolve => {

        Promise.all(calls).then(responses => resolve(responses.map(x => x.data)))
    });
};

const getDataSourcesByNames = async (dataSourcesNames: string[]): Promise<AxiosResponse<IngestionConfig[]>> => {

    let url = urlHelper.buildCollectionParamUrl('ingestion/names', 'names', dataSourcesNames);

    return await httpClient.get<IngestionConfig[]>(url);
}

const getReportFields = async (regime: string) => {
    return await httpClient.get<ReportFieldDefinition[]>('report-field', { regime: regime });
}

const getDataSources = async (dataSourceNames: string[]) => {
    let url = urlHelper.buildCollectionParamUrl('ingestion/names', 'names', dataSourceNames);

    return await httpClient.get<IngestionConfig[]>(url);
}

const getCollections = async (regime: string, dataSourceNames: string[]): Promise<CollectionBundle> => {

    let result = {
        reportFields: [] as ReportFieldDefinition[],
        dataSources: [] as IngestionConfig[]
    } as CollectionBundle;

    let response = await getDataSources(dataSourceNames);

    result.dataSources = response.data;

    let fieldResponse = await getReportFields(regime);

    result.reportFields = fieldResponse.data;

    return result;
};

const importDataSources = async (dataSources: IngestionConfig[]): Promise<void> => {

    for (let i = 0; i < dataSources.length; i++) {
        dataSources[i].ingestionMode = Object.keys(IngestionMode).includes(dataSources[i].ingestionMode) ? dataSources[i].ingestionMode : IngestionMode.Flexible;
        dataSources[i].filenames = dataSources[i].filenames || dataSources[i].name;

        await httpClient.post('ingestion', dataSources[i]);
    }
};

const importReportConfig = async (importReportConfig: ImportReportConfig): Promise<any> => {

    if (!typeHelper.isNumber(importReportConfig.reportConfig.id)) {

        return await httpClient.post('report/import', importReportConfig);
    }

    let url = urlHelper.buildRoute(['report', importReportConfig.reportConfig.id]);

    return await httpClient.put(url, importReportConfig.reportConfig);
};

export {
    getConfigDataSources,
    getCollections,
    importDataSources,
    importReportConfig,
    getDataSourcesByNames,
    getDataSources
};
